import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const ThankYou = () => (
  <div className="min-h-screen bg-black flex flex-col">
    <Navbar />

    {/* Content */}
    <section className="flex-1 flex flex-col items-center justify-center text-center px-4 py-24">
      <h1 className="text-4xl md:text-5xl font-bold text-section-dark-foreground mb-6">
        Thank you for connecting with us!
      </h1>
      <p className="text-section-dark-foreground/80 text-lg md:text-xl max-w-2xl leading-relaxed">
        Please check your spam/junk folder for your confirmation email with the Zoom call details! We look forward to speaking with you.
      </p>
    </section>

    <Footer />
  </div>
);

export default ThankYou;
